<template>
  <div class="dashboard-container">
    <nav class="add-navigation">
      <div class="right-wrapprr row">
        <div class="input-div col-md col-12  my-md-0">
          <span class="filter_by">Start Time:</span>
          <div class="selects-wrapper">
            <date-time-picker
                :initial_time="new Date(startTime)"
                @getTime="getStartTime"
                header_font_size="12"
                header_font_weight="900"
                header_font_color="#000"
            ></date-time-picker>
          </div>
        </div>
        <div class="input-div col-md col-12 my-3 my-md-0">
          <span class="filter_by">End Time:</span>
          <div class="selects-wrapper">
            <date-time-picker
                :initial_time="new Date(endTime)"
                @getTime="getEndTime"
                header_font_size="12"
                header_font_weight="900"
                header_font_color="#000"
            ></date-time-picker>
          </div>
        </div>

        <div class="selects-wraper d-flex col-md col-12  my-md-0">
          <span class="filter_by">Bucketization:</span>
          <primary-select type="text" class="Bucketization" placeholder="Choose">
            <option value="Daily">Daily</option>
            <option value="All Day">All Day</option>
          </primary-select>
        </div>
      </div>
      <div class="left-wrapper">
        <div>
          <div class="search-div">
            <span>Phone Numbers:</span>
            <div class="selects-wrapper">
              <search-input class="search-input" type="text" />
            </div>
          </div>
          <div class="frequentlyused-div">
            <span>Frequently used</span>
            <!-- <div class="frequently-div">
              <div>
                <span>451-541-5590</span>
                <svg
                  data-v-22ac3b44
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  class="svg-grey"
                >
                  <path
                    data-v-22ac3b44
                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
              </div>
              <div>
                <span>451-541-5590</span>
                <svg
                  data-v-22ac3b44
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  class="svg-grey"
                >
                  <path
                    data-v-22ac3b44
                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
              </div>
              <div>
                <span>451-541-5590</span>
                <svg
                  data-v-22ac3b44
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  class="svg-grey"
                >
                  <path
                    data-v-22ac3b44
                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
              </div>
            </div>-->
          </div>
          <div class="selectedus-div">
            <span>SELECTED</span>
            <!-- <div class="selected-div">
              <div>
                <span>451-541-5590</span>
                <svg
                  data-v-22ac3b44
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  class="svg-grey"
                >
                  <path
                    data-v-22ac3b44
                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
              </div>
              <div>
                <span>451-541-5590</span>
                <svg
                  data-v-22ac3b44
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  class="svg-grey"
                >
                  <path
                    data-v-22ac3b44
                    transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </nav>
    <not-found v-if="!is_found" />
    <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header">
            <th class="companyName" rowspan="2">Date</th>
            <th style="min-width: 170px" class="postpay">Incoming SMS</th>
            <th class="contact" colspan="4">Outgoing SMS</th>
          </tr>
          <tr class="Invoice_table_header">
            <th>Count</th>
            <th>Count</th>
            <th>Sent</th>
            <th>Error</th>
            <th>Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>-</th>
            <th style="min-width: 170px">-</th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ResellersLine: () =>
      import("@/components/Charts/Reporting/ResellersLine.js"),
    CompaniesLine: () =>
      import("@/components/Charts/Reporting/CompaniesLine.js"),
    BarChart: () => import("@/components/Charts/Dashboard/BarChart.js"),
    BarChartSecond: () => import("@/components/Charts/Dashboard/BarChart2.js"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    CardComponent: () => import("@/components/CardComponent.vue"),
    Loader: () => import("@/components/Loader.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    DateTimePicker: () => import("@/components/DateTime"),
  },
  data: () => ({
    is_found: false,
  }),
  computed:{
    startTime() {
      const { day, month, year } = this.getCurrentDateAndTime();

      return new Date(`${month}/${day}/${year} 00:00:00`).getTime();
    },
    endTime() {
      const { day, month, year } = this.getCurrentDateAndTime();

      return new Date(`${month}/${day}/${year} 23:59:59`).getTime();
    },
  },
  methods:{

    dateFormat(date) {
      const converted_date = new Date(date);
      const year = converted_date.getFullYear().toString().slice(2, 4);
      const _month = (converted_date.getMonth() + 1).toString();
      const month = this.oneToTwoDigit(_month);
      const day = converted_date.getDate();
      const _hours = converted_date.getHours().toString();
      const hours = this.oneToTwoDigit(_hours);
      const _minutes = converted_date.getMinutes().toString();
      const minutes = this.oneToTwoDigit(_minutes);
      const _seconds = converted_date.getSeconds().toString();
      const seconds = this.oneToTwoDigit(_seconds);

      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    getCurrentDateAndTime() {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return { day, month, year };
    },
    getStartTime(t) {
      // const time = new Date(t).getTime();
      // this.start_time = time / 1000;
      // console.log(t);
    },
    getEndTime(t) {
      // const time = new Date(t).getTime();
      // this.end_time = time / 1000;
      // console.log(t);
    },
  }
};
</script>

<style lang="scss" scoped>
.search-div .search-input {
  width: 100%;
  @media (min-width: 576px) {
    width: 50%;
  }
}

.dashboard-container {
  //padding: 20px;

  .add-navigation {
    padding-bottom: 20px;
  }
  .input-div {
    display: flex;
    align-items: center;
  }
  .right-wrapprr {
    display: flex;
    align-items: center;
  }
  .right-wrapprr > div {
    width: 25%;
  }
  .selects-wrapper {
    display: flex;
    align-items: center;
    background-color: #fff;
    width: 60%;
  }
  .selects-wraper {
    width: 357px;
  }
  .Bucketization {
    width: 60%;
  }

  .filter_by {
    height: 40px;
    color: #55616e;
    font-weight: 400;
    font-family: Helvetica Neue;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 5px 10px 30px;
    @media (max-width: 768px) {
      min-width: 120px;
    }

    &:first-child {
      padding-left: 0;
    }
  }
}

table.Invoice_table {
  width: 100%;
  margin-top: 21px;

  th {
    text-align: center;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
  background: #52a8ef;
  vertical-align: inherit;
}
table thead th:nth-child(2) {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
  background: #52a8ef;
  vertical-align: inherit;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 7px 10px 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 10px 7px 20px;
  text-align: left;
}

tbody th:first-child {
  padding: 5px 10px 5px 0;
  span {
    padding: 7px 0;
  }
}
.left-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.left-wrapper > div {
  background: #fff;
  width: 100%;

  padding: 10px 20px 10px 20px;
}
.search-div {
  .selects-wrapper {
    width: 100%;
  }
  span {
    font-weight: bold;
    font-size: 14px;
  }
}
.frequentlyused-div {
  margin-top: 10px;
  span {
    color: #55616e;
    font-weight: 400;
    font-family: "Helvetica Neue";
    font-size: 15px;
  }
  svg {
    fill: #55616e;
  }
}
.frequently-div {
  display: flex;
  margin-top: 5px;
  flex-wrap: wrap;
}
.frequently-div > div {
  background: #f8f9fe;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30%;
  height: 40px;
  padding: 0 10px;
  border-radius: 3px;
  margin-right: 20px;
  span {
    font-weight: 600;
    color: black;
  }
}
.selectedus-div {
  margin-top: 10px;
  span {
    color: #55616e;
    font-weight: 400;
    font-family: "Helvetica Neue";
    font-size: 15px;
    opacity: 0.5;
  }
  svg {
    fill: #fff;
  }
}
.selected-div {
  display: flex;
  margin-top: 5px;
  flex-wrap: wrap;
}
.selected-div > div {
  background: #54aaec;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30%;
  height: 40px;
  padding: 0 10px;
  border-radius: 3px;
  margin-right: 20px;
  span {
    font-weight: 600;
    color: #fff;
    opacity: 1;
  }
}

@media (max-width: 1400px) {
  .selected-div > div {
    width: 180px;
    margin-top: 5px;
  }
  .frequently-div > div {
    width: 180px;
    margin-top: 5px;
  }
}
@media (max-width: 1300px) {
  table.Invoice_table {
    width: 1385px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

